<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <div>
        <span class="d-flex align-items-center">
          <span>Items Requested/Provided</span>
          <button mat-stroked-button (click)="getDocuments()"
            class="icon-only m-l-05"><mat-icon>refresh</mat-icon></button>
        </span>
        <span class="d-flex align-items-center">
        </span>
      </div>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="m-t-1 m-b-05">The following have been requested/provided for this matter. Please select an item to view
      more information or to upload an item.</div>

    @if(loading){
    <div class="d-flex justify-content-center">
      <mat-spinner></mat-spinner>
    </div>
    }

    @if(!loading && documents){
    <div>
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element">{{element.fileDesc}}</td>
        </ng-container>

        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef>Due Date</th>
          <td mat-cell *matCellDef="let element" [ngClass]="getDueDateClass(element)">{{element.dueDate |  dateTimeFromIso | dateTimeToFormat: 'MMM dd, yyyy'  }}</td>
        </ng-container>

        <ng-container matColumnDef="uploadStatus">
          <th mat-header-cell *matHeaderCellDef>Upload</th>
          <td mat-cell *matCellDef="let element">
            <mat-icon [ngClass]="getStatusClass(element)"
              fontSet="material-symbols-outlined">{{getStatusIcon(element)}}</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element"><mat-icon>chevron_right</mat-icon></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="viewItem(row)"></tr>
      </table>
    </div>
    }
    @if(!loading && documents.length === 0){
    <div class="text-align-center m-t-1">There are currently no items here.
    </div>
    }

    <div class="d-flex justify-content-sb m-t-1">
      <div class="action-links m-r-1">
        <div class="d-flex align-items-center"><mat-icon class="incomplete"
            fontSet="material-symbols-outlined">cloud_upload</mat-icon><span class="m-l-05">Upload Required</span></div>
        <div class="d-flex align-items-center"><mat-icon class="complete"
            fontSet="material-symbols-outlined">check_circle</mat-icon><span class="m-l-05">Complete</span></div>
        <div class="d-flex align-items-center"><mat-icon fontSet="material-symbols-outlined"
            class="error">error_outline</mat-icon><span class="m-l-05">Rejected</span></div>
        <div class="d-flex align-items-center"><mat-icon class="send"
            fontSet="material-symbols-outlined">send</mat-icon><span class="m-l-05">Sent</span></div>
      </div>
      <div>
      <button mat-button mat-flat-button type="button" (click)="addItem()"><mat-icon>add</mat-icon>{{addItemText}}</button>
      </div>
    </div>
  </mat-card-content>
</mat-card>